import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { reserveRoutes } from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { SelectInput } from '../../components/common/components'
import { setResultValue } from '../../actions'
import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'
import { weeks } from '../../utils/utils'


export default function Reserve() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveRoutes, (o) => o.path === location.pathname)

    const result = (useSelector(state => state.getIn(["result", "result"]))).toJS()

    const dispatch = useDispatch()

    let history = useHistory();

    const handleNextClick = () => {

    }

    useEffect(() => {
        if (_.isEmpty(result)) {
            // Swal.fire("無預約資訊", "", "info")
            history.push('/')
        }
        return () => {
            dispatch(setResultValue({ value: {} }))
        }
    }, [])

    return <Box className={layoutClasses.page}>
        <Helmet>
            <title>{reserveRoutes[idx].name}</title>
        </Helmet>
        <ProgressBar />
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center">
                {reserveRoutes[idx].name}
            </Typography>
            <Typography variant="body1" gutterBottom>
                疫苗種類：{result.VACCINE_NAME}
            </Typography>
            <Typography variant="body1" gutterBottom>
                預約代號：{result.TICKET_NO}
            </Typography>
            <Typography variant="body1" gutterBottom>
                身分證字號：{result.PAT_IDNO}
            </Typography>
            <Typography variant="body1" gutterBottom>
                聯絡電話：{result.TEL_MOBILE}
            </Typography>
            <Typography variant="body1" gutterBottom>
                電子郵件：{result.EMAIL}
            </Typography>
            <Typography variant="body1" gutterBottom>
                預約日期：{result.SCHD_DATE_STR}({weeks[result.DAYS_STR]})
            </Typography>
            <Typography variant="body1" gutterBottom>
                預約時段：{result.SCHD_TIME_STR}
            </Typography>
            <Typography variant="body1" gutterBottom>
                施打地點：{result.ARRIVAL_LOCATION}
            </Typography>
            <Typography variant="body1" gutterBottom style={{ color: "red" }}>
                {result.VACC_LST_TXT}
                {/* *接種當日，請務必攜帶執業登記證或工作證及有效工作證明 */}
            </Typography>
        </Paper>
        <Button
            variant="contained"
            color="primary"
            style={{ margin: "30px auto" }}
            onClick={() => { history.push('/search') }}
        >
            至查詢頁面
        </Button>
    </Box>
}